import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '7fr 1fr'
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  table: {
    // borderRadius: 6
    // '& th': {
    //   fontWeight: 'bold',
    //   background: '#f5f5f5',
    //   paddingLeft: 0
    // },
    // '& td': {
    //   paddingLeft: 16
    // }
  },
  valueSection: {
    display: 'flex',
    flexDirection: 'row'
    // background: 'yellow'
  },
  dataContainer: {
    // marginLeft: 24
    // paddingLeft: 24
  },
  horizontalLineForValue: {
    background: theme.palette.grey[700],
    height: 1,
    width: 25,
    marginTop: 14
  }
}))

export default useStyles
